export const Title = ({ text }: { text: string }) => {
  return <h2 className="main-title">{text}</h2>;
};
